var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("transition", { attrs: { name: "cc-drawer-slide" } }, [
        _vm.panelOpen
          ? _c(
              "aside",
              {
                ref: "panel",
                staticClass: "cc-drawer",
                attrs: { "aria-label": "Guia de configuração", tabindex: "-1" }
              },
              [
                _c("div", { staticClass: "cc-drawer__inner" }, [
                  _c("header", { staticClass: "cc-drawer__header" }, [
                    _c(
                      "button",
                      {
                        staticClass: "cc-drawer__icon-btn",
                        attrs: {
                          type: "button",
                          "aria-label": _vm.labelVoltar,
                          title: _vm.labelVoltar
                        },
                        on: { click: _vm.voltarDoGuia }
                      },
                      [
                        _c("icon-svg", {
                          attrs: {
                            name: "mdi-arrow-left",
                            size: 20,
                            color: "var(--neutral-600)"
                          }
                        })
                      ],
                      1
                    ),
                    _c("span", { staticClass: "cc-drawer__eyebrow" }, [
                      _vm._v("Jornada de configuração")
                    ]),
                    _c("span", { staticClass: "cc-drawer__hspacer" }),
                    _c(
                      "button",
                      {
                        staticClass: "cc-drawer__icon-btn",
                        attrs: {
                          type: "button",
                          "aria-label": "Recolher guia",
                          title: "Recolher"
                        },
                        on: { click: _vm.onCollapse }
                      },
                      [
                        _c("icon-svg", {
                          attrs: {
                            name: "mdi-arrow-collapse-right",
                            size: 18,
                            color: "var(--neutral-600)"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "cc-drawer__icon-btn",
                        attrs: {
                          type: "button",
                          "aria-label": "Fechar e cancelar a jornada",
                          title: "Fechar"
                        },
                        on: { click: _vm.onClose }
                      },
                      [
                        _c("icon-svg", {
                          attrs: {
                            name: "mdi-close",
                            size: 20,
                            color: "var(--neutral-600)"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm.journeyStale
                    ? _c("p", { staticClass: "az-ds-aux cc-stale" }, [
                        _vm._v(
                          " Sincronização desatualizada — atualize a página. "
                        )
                      ])
                    : _vm._e(),
                  _vm.hasContext
                    ? _c(
                        "div",
                        { staticClass: "cc-drawer__scroll" },
                        [
                          _c(
                            "div",
                            { staticClass: "cc-task" },
                            [
                              _c("IconWithBackground", {
                                attrs: {
                                  "container-size": 40,
                                  icon: _vm.taskIcon,
                                  "icon-size": 20,
                                  color: "primary"
                                }
                              }),
                              _c("div", { staticClass: "cc-task__body" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "az-ds-card-title cc-task__name"
                                  },
                                  [_vm._v(" " + _vm._s(_vm.taskName) + " ")]
                                ),
                                _c(
                                  "span",
                                  { staticClass: "az-ds-aux cc-task__meta" },
                                  [_vm._v(" " + _vm._s(_vm.metaLine) + " ")]
                                )
                              ])
                            ],
                            1
                          ),
                          _vm.temPosicaoNoGrupo
                            ? _c("div", { staticClass: "cc-progress" }, [
                                _c("span", {
                                  staticClass: "cc-progress__fill",
                                  style: { width: _vm.progressPercent + "%" }
                                })
                              ])
                            : _vm._e(),
                          _vm.tarefaEhVitrine
                            ? _c(
                                "p",
                                { staticClass: "cc-vitrine-aviso" },
                                [
                                  _c("icon-svg", {
                                    attrs: {
                                      name: "mdi-lock-outline",
                                      size: 14,
                                      color: "var(--neutral-600)"
                                    }
                                  }),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.vitrineTooltip))
                                  ])
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.hasLocation && !_vm.tarefaEhVitrine
                            ? _c(
                                "button",
                                {
                                  staticClass: "cc-gochip",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      return _vm.navigate(_vm.task.url)
                                    }
                                  }
                                },
                                [
                                  _c("icon-svg", {
                                    attrs: {
                                      name: "mdi-open-in-new",
                                      size: 14,
                                      color: "var(--primary)"
                                    }
                                  }),
                                  _c(
                                    "span",
                                    { staticClass: "cc-gochip__text" },
                                    [_vm._v("Ir para " + _vm._s(_vm.location))]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.hasInstructions
                            ? _c("CentralConfigStepGuide", {
                                staticClass: "cc-block",
                                attrs: { instructions: _vm.instructions }
                              })
                            : _vm._e(),
                          _vm.hasRequires
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "az-card-bordered rounded-sm cc-requires-card cc-block"
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "az-ds-label cc-requires-title"
                                    },
                                    [_vm._v("PRÉ-REQUISITOS")]
                                  ),
                                  _c(
                                    "ul",
                                    { staticClass: "cc-requires" },
                                    _vm._l(_vm.requiresTasks, function(
                                      require
                                    ) {
                                      return _c(
                                        "li",
                                        {
                                          key: require.id,
                                          staticClass: "cc-requires__item"
                                        },
                                        [
                                          require.isDone
                                            ? _c("icon-svg", {
                                                attrs: {
                                                  name: "check-circle",
                                                  size: 16,
                                                  color: "var(--success)"
                                                }
                                              })
                                            : _c("span", {
                                                staticClass:
                                                  "cc-dot cc-dot--todo"
                                              }),
                                          _c(
                                            "span",
                                            { staticClass: "az-ds-card-title" },
                                            [_vm._v(_vm._s(require.name))]
                                          )
                                        ],
                                        1
                                      )
                                    }),
                                    0
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm.loadingContext
                    ? _c(
                        "div",
                        { staticClass: "cc-drawer__scroll" },
                        [
                          _c("BaseLoadingSkeleton", {
                            staticClass: "mb-3",
                            attrs: { height: "48px" }
                          }),
                          _c("BaseLoadingSkeleton", {
                            staticClass: "mb-3",
                            attrs: { height: "4px" }
                          }),
                          _c("BaseLoadingSkeleton", {
                            attrs: { height: "80px" }
                          })
                        ],
                        1
                      )
                    : _vm.loadError
                    ? _c(
                        "div",
                        { staticClass: "cc-drawer__scroll cc-drawer__state" },
                        [
                          _c("p", { staticClass: "az-ds-body" }, [
                            _vm._v(
                              " Não foi possível carregar esta etapa. Tente novamente ou contate o suporte se o problema persistir. "
                            )
                          ]),
                          _c(
                            "BaseButton",
                            {
                              attrs: { primary: "" },
                              on: { click: _vm.loadContext }
                            },
                            [_vm._v("Tentar novamente")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.autoriaLinha
                    ? _c(
                        "p",
                        {
                          staticClass: "az-ds-aux cc-autoria",
                          attrs: { id: "cc-autoria" }
                        },
                        [_vm._v(" " + _vm._s(_vm.autoriaLinha) + " ")]
                      )
                    : _vm._e(),
                  _vm.hasContext
                    ? _c(
                        "footer",
                        { staticClass: "cc-drawer__footer" },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "cc-check",
                              class: { "cc-check--done": _vm.isDone },
                              attrs: {
                                type: "button",
                                disabled: _vm.marking || _vm.tarefaEhVitrine,
                                "aria-pressed": _vm.isDone ? "true" : "false",
                                "aria-describedby": _vm.autoriaId
                              },
                              on: { click: _vm.toggleTaskStatus }
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "cc-check__box" },
                                [
                                  _vm.marking
                                    ? _c("v-progress-circular", {
                                        attrs: {
                                          indeterminate: "",
                                          size: 13,
                                          width: 2,
                                          color: "primary"
                                        }
                                      })
                                    : _vm.isDone
                                    ? _c("icon-svg", {
                                        attrs: {
                                          name: "mdi-check",
                                          size: 13,
                                          color: "var(--white)"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c("span", [_vm._v(_vm._s(_vm.checkLabel))])
                            ]
                          ),
                          _c("span", { staticClass: "cc-drawer__hspacer" }),
                          _vm.prevTask
                            ? _c(
                                "BaseButton",
                                {
                                  staticClass: "cc-drawer__prev",
                                  attrs: {
                                    bordered: "",
                                    "min-width": "0",
                                    loading: _vm.navigating,
                                    "aria-label": "Etapa anterior"
                                  },
                                  on: { click: _vm.goPrev }
                                },
                                [
                                  _c("icon-svg", {
                                    attrs: {
                                      name: "mdi-arrow-left",
                                      size: 18,
                                      color: "var(--neutral-600)"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "BaseButton",
                            {
                              staticClass: "cc-drawer__next",
                              attrs: {
                                primary: "",
                                "min-width": "0",
                                loading: _vm.navigating
                              },
                              on: { click: _vm.goNext }
                            },
                            [_vm._v(" " + _vm._s(_vm.primaryLabel) + " ")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ]
            )
          : _vm._e()
      ]),
      _c("transition", { attrs: { name: "cc-fab-pop" } }, [
        _vm.fabOpen
          ? _c(
              "button",
              {
                staticClass: "cc-fab",
                attrs: {
                  type: "button",
                  "aria-label": "Reabrir jornada de configuração"
                },
                on: { click: _vm.onExpand }
              },
              [
                _c("IconWithBackground", {
                  attrs: {
                    "container-size": 30,
                    icon: "mdi-compass-outline",
                    "icon-size": 30,
                    color: "white",
                    transparent: ""
                  }
                })
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }